import styled from 'styled-components';

import { Card, Container } from '../../../common/Styles';

export const BenefitsContainer = styled(Container)`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ImgBackground = styled.img`
    height: 100%;
    width: 100%;
    position: absolute;
    top:0;
    z-index: 0;
    object-fit: cover;
    background-image: linear-gradient(83deg ,#723b63 2%,#4c2340 97%);
`;

export const ImgbgWrap = styled.div(
	({ theme: { down, between, breakpoints } }) => `
          position: relative;
          background: #f5f5f5;
          height: auto;
        }
          ${down(breakpoints.tb)} {
            margin-bottom: 40px;
          }
          ${between(breakpoints.xs, breakpoints.md)} {
            margin-bottom: 0;
          }
          ${down(breakpoints.xs)} {
            margin-bottom: 40px;
          }
        `
);

export const VideoOverlayWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
  `;

export const VideoOverlayContent = styled.div`
    position: absolute;
    text-align: center;
    top: 30%;
    left: 30%;
    color: #fff;
  `;

export const VideoPlayerWrap = styled.div`
    width: 100%;
    height: 525px;
    background: #000;
    position: relative;
    margin-top: -45px;
    border-radius: 8px;
    > div {
        border-radius: 8px;
      > div {
        border-radius: 8px;
      }
    }
    video {
      outline: 0;
    }
  `;

export const BenefitsListWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
      
              ${down(breakpoints.tb)} {
                overflow-x: scroll;
                margin-left:20px;
                >article{
                    min-width: 40%;
                    margin-right: 8px;
                }
              }
              ${down(breakpoints.md)} {
                  overflow-x: scroll;
                  margin-left:20px;
                  >article{
                      min-width: 88%;
                      margin-right: 8px;
                  }
              }
              max-width: 1200px; 
              width: 100%;
              margin: 0 auto;
              display: flex;
              margin-top: -100px;
              min-height: 300px;
              
              >article{
                  &:last-child{
                      margin-right: 0;
                  }
              }
          
            `
);

export const ExtendCard = styled(Card)`
  flex: 1;
  position: relative;
  padding-bottom: 52px;
  `;
export const BenefitsList = styled.ul(
	({ theme: { down, breakpoints } }) => `
      ${down(breakpoints.md)} {
      }
      >li{
          font-size: 16px;
          padding-bottom: 32px;
          display: flex;
          align-items: baseline;
          >span{
              margin-right: 10px;
          }
          &:first-child{
              padding-top: 24px;
          }
      }
      padding-right: 10px;
      max-height: 280px;
      overflow: auto;   
          `
);

export const KnowMoreLink = styled.span`
    color: #ff664b;
    font-size: 16px;
    font-weight: 900;
    display: flex;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
  `;

export const BtnOuterWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
    width: 50%;
    position: relative;
    padding: 50px 0 70px 0;
     button {
      &:first-child {
        margin-right: 20px;
      }
    }
          ${down(breakpoints.md)} {
             padding: 30px 0 25px 0;
             width: 100%;
          }  
        `
);

export const BtnWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
     button {
      &:first-child {
        margin-right: 20px;
      }
    }
          ${down(breakpoints.md)} {
            button {
              &:first-child {
                margin-bottom: 10px;
              }
            }
          }  
        `
);

export const BenefitListOuterWrap = styled.div`
    overflow: hidden;
    position: relative;
  `;

export const BenefitCurveWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
      height: 65%;
      width: 100%;
      position: absolute;
      left: 0%;
      top: 52%;
      overflow: hidden;
      ${down(breakpoints.tb)} {
        top: 40%;
        height:65%;
      }
      `
);

export const BenefitsCurve = styled.div`
      height: 100%;
      background: #fff;
      border-radius: 50% / 150px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      position: absolute;
      left: 50%;
      top: 0%;
      bottom: 0;
      width: calc(100% * 1.4);
      transform: translateX(-50%);
      bottom: 0;
    `;

export const BenefitListTitleWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
    padding-top: 5%;
    padding-bottom: 10%;
    h4, p{
      width: 50%;
    }
    ${down(breakpoints.tb)} {
      padding-bottom: 18%;
    }  
    ${down(breakpoints.md)} {
        padding-bottom: 160px;
        h4, p{
          width: 100%;
        }
      }  
    `
);

export const typeImg = styled.img`
      width: 40px;
      height: 40px;
      object-fit: cover;
      margin-bottom: 16px;
  `;
